// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"298":"45e6b777","315":"ucare-panel-chunk","923":"ucare-widget-chunk"}[chunkId] + "." + {"298":"81b1f56831593058","315":"b982d4dd38d7a877","923":"51e9e3e2ef86192a"}[chunkId] + ".js";
};